// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ITitleCancelReasonType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class TitleCancelReasonType implements ITitleCancelReasonType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Canceled - Transferred Out of State TitleCancelReasonType
	**/
    get CanceledTransferredOutofState(): ITitleCancelReasonType {
        return this.FromId(1);
    }
    /**
		Returns Entered In Error TitleCancelReasonType
	**/
    get EnteredInError(): ITitleCancelReasonType {
        return this.FromId(3);
    }
    /**
		Returns Fraud TitleCancelReasonType
	**/
    get Fraud(): ITitleCancelReasonType {
        return this.FromId(4);
    }
    /**
		Returns NSF TitleCancelReasonType
	**/
    get NSF(): ITitleCancelReasonType {
        return this.FromId(5);
    }
    /**
		Returns UNDO - Transferred Out of State TitleCancelReasonType
	**/
    get UNDOTransferredOutofState(): ITitleCancelReasonType {
        return this.FromId(6);
    }
    /**
		Returns Entered in Error - Re-Establish TitleCancelReasonType
	**/
    get EnteredInErrorReEstablish(): ITitleCancelReasonType {
        return this.FromId(7);
    }
    /**
    Returns Affixed Mobile Home TitleCancelReasonType
    **/
    get AffixedMobileHome(): ITitleCancelReasonType {
        return this.FromId(1005);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Canceled-TransferredOutofState', displayValue: 'Canceled - Transferred Out of State', description: 'Canceled - Transferred Out of State', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'EnteredInError', displayValue: 'Entered In Error', description: 'Entered In Error', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Fraud', displayValue: 'Fraud', description: 'Title was obtained fraudulently', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'NSF', displayValue: 'NSF', description: 'Non-Sufficient Funds', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'UNDO-TransferredOutofState', displayValue: 'UNDO - Transferred Out of State', description: 'UNDO - Transferred Out of State', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'EnteredInError-Re-Establish', displayValue: 'Entered in Error - Re-Establish', description: 'Used to reestablish previous ownership when a transfer was done in error.  aka VOID', sortOrder: 999999, active: true });
        this._dictionary.add('1005', { id: 1005, value: 'AffixedMobileHome', displayValue: 'Affixed Mobile Home', description: 'Mobile home was affixed so the record is now in mobile home system', sortOrder: 9999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ITitleCancelReasonType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ITitleCancelReasonType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ITitleCancelReasonType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ITitleCancelReasonType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ITitleCancelReasonType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
